<template>
  <button
    class="flex items-center justify-center rounded-full px-4 py-2 w-2/3
      bg-gray-200 shadow-md
       border hover:border-black -transition-all duration-200">
    <component :is="`ebr-icon-${icon}`" ></component>
    {{label}}
  </button>
</template>

<script>
import BarcaVue from '../icons/Barca.vue';
import PatenteVue from '../icons/Patente.vue';
import SenzaPatenteVue from '../icons/SenzaPatente.vue';

export default {
  name: 'RoundButtonWithIcon',
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
  },
  components: {
    'ebr-icon-barca': BarcaVue,
    'ebr-icon-patente': PatenteVue,
    'ebr-icon-senza-patente': SenzaPatenteVue,
  },
};
</script>

<style lang="scss" scoped>

</style>
